import React from "react"
import Container from "./IconContainer"


const CheckCircleIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="14px"
      height="13px"
      viewBox="0 0 14 13"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190624-V1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="3b_UrgentCare-hours"
          transform="translate(-217.000000, -676.000000)"
          stroke="#196CFF"
        >
          <g id="Group-2" transform="translate(32.000000, 671.000000)">
            <g id="check-circle" transform="translate(186.000000, 5.000000)">
              <path
                d="M11.4285714,5.75428571 L11.4285714,6.28571429 C11.4271245,8.81639192 9.76131083,11.0446931 7.33448709,11.7622291 C4.90766335,12.4797651 2.29793917,11.5156069 0.920545763,9.39260934 C-0.456847643,7.26961174 -0.273792317,4.49350799 1.3704424,2.56975551 C3.01467711,0.646003035 5.72840723,0.032871591 8.04,1.06285714"
                id="Shape"
              />
              <polyline
                id="Shape"
                points="12 1.14285714 5.71428571 7.42857143 4 5.71428571"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default CheckCircleIcon


// WEBPACK FOOTER //
// ./assets/common/components/icons/CheckCircleIcon.js